import { render } from "./BoxTotalExit.vue?vue&type=template&id=56125522"
import script from "./BoxTotalExit.vue?vue&type=script&lang=js"
export * from "./BoxTotalExit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__